import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, TextField, Typography, Container, Checkbox, FormControlLabel, Link, Grid, InputAdornment, Alert, IconButton, CircularProgress, Dialog, DialogContent, DialogActions } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { IconArrowLeftToArc, IconArrowRight, IconArrowRightFromArc, IconArrowRightToArc, IconCircleCheck, IconEye, IconEyeOff, IconLock, IconMail, IconUserPlus } from '@tabler/icons-react';
import { set, useForm } from 'react-hook-form';
import SignInImage from '../../Images/smilingman1.png';
import axios from 'axios';
import PageContainer from '../MainPages/PageContainer';
import ReCAPTCHA from 'react-google-recaptcha';
import logoimg from '../../Images/autosdlc.png';
const SignIn = () => {
  const recaptchaRef = useRef(null);
  const navigate = useNavigate()
  const [Apierror, setApiError] = useState('')
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const { register, handleSubmit, formState: { errors }, setValue, trigger ,getValues} = useForm();
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [verify,setverify]= useState('')
  const [showsuccesspopup,setShowsuccesspopup]=useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const postCaptcha = async (token) => {
    try {
      let req = {
        recaptcha_token: token
      }
      const response = await axios.post('/apiV1/protected/',req);
      console.log(response);
    }
    catch (error) {
      console.log('Error generating test:', error.response ? error.response.data : error.message);
    }
  }
  const onSubmit = async (data) => {
    const token = recaptchaRef.current.getValue(); 
    if (!token) {
      setApiError('Please complete the reCAPTCHA.');
      return;
    }
    try {
      setLoading(true);
      let req = {
        email: data.email,
        password: data.password,
      };
      if (data.rememberMe) {
        sessionStorage.setItem("username", data.email)
        sessionStorage.setItem("Password", data.password)
      } else {
        sessionStorage.removeItem("username")
        sessionStorage.removeItem("Password")
      }
      const response = await axios.post('/apiV1/login/', req);
      if (response.status === 200) {
        sessionStorage.setItem("AdminToken", response.data.access)
        await userInfo()
          setLoading(false);
          navigate('/Dashboard');
      }
    } catch (error) {
      setApiError(error?.response.data?.message);
      console.error('Error generating test:', error.response ? error.response.data : error.message);
      setverify(error?.response?.data?.is_verified);
      setApiError(error?.response?.data?.message)
      setLoading(false);
    }

  };
  const userInfo = async () => {
    try {
      const config = axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("AdminToken")}` }
      const response = await axios.get('/apiV1/user-info/', config);
      console.log(response.data);
      if (response.status == 200) {
        sessionStorage.setItem("user-info", JSON.stringify(response.data))
      }
    } catch (error) {
      console.error('Error generating test:', error.response ? error.response.data : error.message);
    }
  }
  useEffect(() => {
    const savedEmail = sessionStorage.getItem('username');
    const savedPassword = sessionStorage.getItem('Password');
    if (savedEmail && savedPassword) {
      setValue('email', savedEmail);
      setValue('password', savedPassword);
    }
  }, []);
  const ResendEmail =async()=>
  {
    setLoading1(true)
    let req={
      phone:getValues("email")
    }
    try
    {
      const response = await axios.post('/apiV1/resend-otp-email/',req)
      console.log(response);
      if (response.status == 200) {
          setLoading1(false)
          setApiError('')
          setverify("")
          setShowsuccesspopup(true)
      }
      
    }catch(error)
    {
      console.log(error)
      setLoading1(false)
    }
  }
  return (
    <>
    <PageContainer title="Auto SDLC | Sign In">
    <Container maxWidth={false} sx={{ height: '100vh', display: 'flex' }}>
      <Grid container>
        {/* Left Section */}
        <Grid
          item
          xs={12}
          md={5}
          sx={{
            bgcolor: '#fff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            // p: { xs:1, md:2 }
            p:2
          }}
        >
          <Box
            sx={{
              background: 'linear-gradient(166deg, #082A68 0%, #591CC2 100%)',
              display: 'flex',
              flexDirection: 'column',
              // p: { xs: 4, md: 22,sm:10 },
              p:13,
              width: '100%',
              borderRadius: 2,
              color: "#fff"
            }}
          >
             <Box
              component="img"
              src={SignInImage}
              alt="Sign In"
              sx={{
                // maxWidth: { xs: '80%', md: '90%' }, 
                height: 'auto', 
                maxWidth: '70%', height: 'auto', mb: 4

              }}
            />
            <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
              Take The First Step!
            </Typography>
            <Typography variant="body1" sx={{ mb: 4 }}>
              Your Journey Starts Here. Create Your Account To Explore New Possibilities.
            </Typography>
            <Box sx={{ alignItems: "center" }}>

              <Button
                component={RouterLink}
                to="/signup"
                variant="contained"
                size="small"
                sx={{ gap: 1, bgcolor: "#7a5af9" }}
              >
                Sign Up <IconUserPlus />
              </Button>
            </Box>

          </Box>
        </Grid>

        {/* Right Section */}
        <Grid
          item
          xs={12}
          md={7}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            p: 4,
            bgcolor: "#fff",
          }}
        >
          <Box sx={{ maxWidth: 450, mx: 'auto', width: '100%',boxShadow:3 ,p:3}}>
            <Box sx={{mb: 2 ,display:"flex",justifyContent:"center"}}>
              <img src={logoimg} alt="logo" style={{ width: "200px" }} />
            </Box>
            <Typography sx={{mb:1,fontWeight:600,textAlign:"center"}}>Welcome! Sign in to your Account</Typography>
            {/* <Typography variant="h5" sx={{mb:1,fontWeight:600}}>Sign to your Account</Typography> */}
            <Box
              component="form"
              onSubmit={handleSubmit(onSubmit)}
              sx={{ display: 'flex', flexDirection: 'column' }}
            >
              {/* Email Field */}
              <TextField
                fullWidth
                placeholder="Email"
                variant="outlined"
                margin="normal"
                type="email"
                {...register('email', {
                  required: 'Email is required',
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: 'Enter a valid email',
                  },
                })}
                error={!!errors.email}
                helperText={errors.email?.message}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconMail size={22} />
                    </InputAdornment>
                  ),
                }}
                onKeyUp={() => { trigger('email'); setApiError('') }}
                onInput={(e) => {e.target.value = e.target.value.toLowerCase()}}
              />

              {/* Password Field */}
              <TextField
                fullWidth
                variant="outlined"
                margin="normal"
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                {...register("password", {
                  required: "Password is required",
                  pattern: {
                    value: /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,16}$/,
                    message: "Password must be 8-16 characters, with at least one digit, one lowercase, and one uppercase letter.",
                  },
                })}
                error={!!errors.password}
                helperText={errors.password?.message}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconLock size={22} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility} edge="end">
                        {showPassword ? <IconEye size={22} /> : <IconEyeOff size={22} />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                onKeyUp={() => { trigger('password'); setApiError('') }}
              />

              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 2 ,ms:2}}>
                <FormControlLabel
                  control={<Checkbox {...register('rememberMe')} />}
                  label="Remember Me"
                />
                <Typography onClick={() => navigate('/forgot-password')} sx={{ cursor: 'pointer', ml: 1, color: 'primary.main', textDecoration: 'underline', textAlign: "center" }}>
                  Forgot Your Password?
                </Typography>
              </Box>
              <Box mt={1} display="flex" justifyContent="start">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6LdNDO8qAAAAAKop53l4KdHbBpnJWv5czY7TOcdI"
                onChange={(token) => {postCaptcha(token);
                  setRecaptchaToken(token);
                  setApiError("");
                }} />
              </Box>
              <Box sx={{mt:1}}>
              {Apierror && <Alert severity="error">{Apierror}</Alert>}
              {verify == 'False'&&<Button sx={{mt:1}} onClick={ResendEmail} disabled={loading||loading1}>
              {loading1 ? (
                  <CircularProgress size={24} sx={{ color: '#fff' }} />
                ) : (
                  <>
                    Resend Link
                  </>
                )}</Button>}
              </Box>
              {/* Submit Button */}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="small"
                sx={{ mt: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                disabled={loading ||loading1} // Disable button during loading
              >
                {loading ? (
                  <CircularProgress size={24} sx={{ color: '#fff' }} />
                ) : (
                  <>
                    Sign In <IconArrowRightToArc />
                  </>
                )}
              </Button>

              {/* <Box sx={{ display: "flex", mt: 2, alignItems: "center", textAlign: 'center', marginLeft: "5rem" }}>
                <Typography>Don't have an account?</Typography>
                <Typography onClick={() => navigate('/signup')} sx={{ cursor: 'pointer', ml: 1, color: 'primary.main', textDecoration: 'underline', textAlign: "center" }}>
                  Sign Up
                </Typography>
              </Box> */}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
    <Dialog
          open={showsuccesspopup}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              setShowsuccesspopup(false);
            }
          }}
          aria-labelledby="success-dialog-title"
          aria-describedby="success-dialog-description"
          maxWidth="sm"
          fullWidth
        >
          <DialogContent>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "5px", gap: 1 }}>
              <IconCircleCheck size={80} color="#7a5afc" />
              <Box>
                <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "600", fontSize: "2rem", color: '#7a5afc' }} >
                  Success!
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "500", fontSize: "1rem" }}>
                  Verification link has been sent to your email.
                </Typography>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              size="small"
              sx={{
                backgroundColor: "#7a5afc",
                color: "white",
                "&:hover": {
                  backgroundColor: "#5d1ac0",
                },
                textTransform: "none",
              }}
              onClick={() => { setShowsuccesspopup(false) }}
            >
              Okay
            </Button>
          </DialogActions>
        </Dialog>
    </PageContainer>
    </>
  );
};

export default SignIn;
